<template>
  <div class="table-container table__theme-default mt-3">
    <table class="table b-table table-hover table-bordered bg-white">
      <thead>
        <tr>
          <th scope="col" class="text-center font-weight-bold text-dark" colspan="12">Key indicators (для расчёта totals)</th>
        </tr>
        <tr>
          <th scope="col" class="th-else col-1 text-center font-weight-bold"
              v-b-tooltip.hover="{ variant: 'base' }" title="Billable hours / Working hours (prod department)">COM (Billability)</th>
          <th scope="col" class="th-else col-2 text-center font-weight-bold">Hours</th>
          <th scope="col" class="th-else col-2 text-center font-weight-bold">Diff with PL and prepaid</th>
          <template v-if="showAllFields">
            <th scope="col" class="th-else col-2 text-center font-weight-bold">Payouts</th>
            <th scope="col" class="th-else col-2 text-center font-weight-bold">Expenses</th>
          </template>
          <th scope="col" class="th-else col-2 text-center font-weight-bold">Overhead</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td scope="col" rowspan="4" class="col-1 text-center">{{keyIndicators.billability}}%</td>
          <td scope="col" class="col-2">
            <div class="d-flex justify-content-between">Working (prod department): <span>{{keyIndicators.hoursWorkingProdDep}}</span></div>
          </td>
          <td scope="col" class="col-2"
            v-b-tooltip.hover="{ variant: 'base' }"
            :title="getTooltipText('diffWithPLAmount')"
          >
            <div class="d-flex justify-content-between">Amount (diff with pl): <span>${{keyIndicators.diffWithPLAmount}}</span></div>
          </td>
          <template v-if="showAllFields">
            <td scope="col" class="col-2">
              <div class="d-flex justify-content-between">Prod department: <span>${{keyIndicators.payoutsProdDep}}</span></div>
            </td>
            <td scope="col" class="col-2">
              <div class="d-flex justify-content-between">Regular: <span>${{keyIndicators.expensesRegular}}</span></div>
            </td>
            <td scope="col" class="col-2"
              v-b-tooltip.hover="{ variant: 'base' }"
              title="Expenses (regular) + Payouts (non-prod department)"
            >
              <div class="d-flex justify-content-between">Monthly <span>${{keyIndicators.overheadAmount}}</span></div>
            </td>
          </template>
          <template v-else>
            <td scope="col" class="col-2"
              v-b-tooltip.hover="{ variant: 'base' }"
              title="Overhead (monthly) / Hours (working of prod department)"
            >
              <div class="d-flex justify-content-between">Hourly <span>${{keyIndicators.overheadHourly}}</span></div>
            </td>
          </template>
        </tr>
        <tr>
          <td scope="col" class="col-2">
            <div class="d-flex justify-content-between">Billable hours: <span>{{keyIndicators.hoursBillable}}</span></div>
          </td>
          <td scope="col" class="col-2"
            v-b-tooltip.hover="{ variant: 'base' }"
            :title="getTooltipText('prepaidHours')"
          >
            <div class="d-flex justify-content-between">Prepaid hours: <span>{{keyIndicators.prepaidHours}}</span></div>
          </td>
          <template v-if="showAllFields">
            <td scope="col" class="col-1">
              <div class="d-flex justify-content-between">Non-prod department: <span>${{keyIndicators.payoutsNonProdDep}}</span></div>
            </td>
            <td scope="col" class="col-1">
              <div class="d-flex justify-content-between">Project related: <span>${{keyIndicators.expensesProjectRelated}}</span></div>
            </td>
            <td scope="col" class="col-1"
              v-b-tooltip.hover="{ variant: 'base' }"
              title="Overhead (monthly) / Hours (working of prod department)"
            >
              <div class="d-flex justify-content-between">Hourly <span>${{keyIndicators.overheadHourly}}</span></div>
            </td>
          </template>
          <template v-else>
            <td scope="col" class="col-1"
              v-b-tooltip.hover="{ variant: 'base' }"
              title="Overhead (monthly) / (Expenses all + Payouts all)"
            >
              <div class="d-flex justify-content-between">Monthly % <span>{{keyIndicators.overheadPercent}}%</span></div>
            </td>
          </template>
        </tr>
        <tr>
          <td scope="col" class="col-1">
            <div class="d-flex justify-content-between">Working + sick and vacations (all) <span>{{keyIndicators.hoursWorkingSickDayVacationAll}}</span></div>
          </td>
          <td scope="col" class="col-2"
            v-b-tooltip.hover="{ variant: 'base' }"
            :title="getTooltipText('prepaidAmount')"
          >
            <div class="d-flex justify-content-between">Prepaid amount: <span>${{keyIndicators.prepaidAmount}}</span></div>
          </td>
          <template v-if="showAllFields">
            <td scope="col" class="col-1">
              <div class="d-flex justify-content-between">Partner’s extra payments: <span>${{keyIndicators.payoutsPartnerExtraPayments}}</span></div>
            </td>
            <td scope="col" class="col-1">
              <div class="d-flex justify-content-between">All: <span>${{expensesAll}}</span></div>
            </td>
            <td scope="col" class="col-1"
              v-b-tooltip.hover="{ variant: 'base' }"
              title="Overhead (monthly) / (Expenses all + Payouts all)"
            >
              <div class="d-flex justify-content-between">Monthly % <span>{{keyIndicators.overheadPercent}}%</span></div>
            </td>
          </template>
          <template v-else>
            <td colspan="2"></td>
          </template>
        </tr>
        <tr>
          <td colspan="2"></td>
          <template v-if="showAllFields">
            <td scope="col" class="col-1">
              <div class="d-flex justify-content-between">All: <span>${{payoutsAll}}</span></div>
            </td>
            <td></td>
          </template>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'pp-key-indicators-table',
  props: {
    keyIndicators: {
      type: Object,
      default: () => {}
    },
    showAllFields: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    expensesAll () {
      const expensesAll = this.keyIndicators.expensesRegular + this.keyIndicators.expensesProjectRelated
      return expensesAll.toFixed(2)
    },
    payoutsAll () {
      const expensesAll = this.keyIndicators.payoutsProdDep + this.keyIndicators.payoutsNonProdDep + this.keyIndicators.payoutsPartnerExtraPayments
      return expensesAll.toFixed(2)
    }
  },
  methods: {
    getTooltipText (field) {
      if (field === '') {

      } else if (field === 'diffWithPLAmount') {
        return `The difference between values of PL revenue and PP revenue.

Revenue:

Revenue. PL - фактически оплаченные деньги в месяце

Revenue. PP (project) - деньги оплаченные в любом месяце на за текущий период

Revenue. PP (people) - деньги оплаченные в любом месяце, за текущий период и отработанные (часы проходят как billable hours - закрытые часы)`
      } else if (field === 'prepaidHours') {
        return `Column billable hours (value in brackets) and this is equivalent of prapaid hours in Hours and Payments reports`
      } else if (field === 'prepaidAmount') {
        return `Prepaid hours * average external rate)`
      }
    }
  }
}
</script>
